<template>
  <div>

    <v-btn
        color="success"
        @click="controlConfirmation()"
        dark
        fixed
        bottom
        right
        :disabled="disabled"
        fab> 
        <v-icon>mdi-content-save-outline</v-icon>
    </v-btn>

    <!-- CONFIRMACIÓN DE GUARDADO -->
    <confirmation v-model="dialogConfirmSave"
      :text="confirmationText"
      :textButton="$t('confirmation.saveButton')"
      :colorButton="`success`"
      @confirm="submit()"/>

  </div>
</template>

<script>

  import Confirmation from "~/components/Confirmation"

  export default {
    name: "FloatingButtonSave",
    components: {
      Confirmation
    },
    props: {
      valid: {
        type: Boolean
      },
      item: {
        type: String,
        default: ''
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
         dialogConfirmSave: false
      }
    },
    computed: {
      confirmationText() {
        return this.item
          ? this.$t('confirmation.saveItemText', { item: this.item })
          : this.$t('confirmation.saveText')
      }
    },
    watch: {
      valid: function(e){
        this.valid = e
      }
    },
    methods: {
      controlConfirmation(){
        if (this.valid) this.dialogConfirmSave = true
        else this.submit()
      },
      submit(){
        this.dialogConfirmSave = false
        this.$emit('submit')
      }
    }
  }
</script>
